module.exports = __webpack_public_path__ + "img/img-1.ced8fae5.svg";